import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import rightImgDemo from "images/BecomeAnAuthorImg.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Logo from "shared/Logo/Logo";
import { RootState } from "store";
import { useSelector } from "react-redux";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import becomeAuthor from "images/become-author.png";

export interface SectionBecomeAnAuthorProps {
  className?: string;
  rightImg?: string;
}

const SectionBecomeAVendor: FC<SectionBecomeAnAuthorProps> = ({
  className = "",
  rightImg = rightImgDemo,
}) => {
  const { userInfo } = useSelector((state: RootState) => state.userInfo);
  return (
    <div
      className={`nc-SectionBecomeAnAuthor relative flex flex-col lg:flex-row items-center  ${className}`}
      data-nc-id="SectionBecomeAnAuthor"
    >
      <div className="flex-shrink-0 mb-16 lg:mb-0 lg:mr-10 lg:w-2/5">
        <Logo className="w-20" />
        <h2 className="font-semibold text-3xl sm:text-4xl mt-6 sm:mt-11">
          Pengen dapetin penghasilan tambahan dari Rentrips?
        </h2>
        <span className="block mt-6 text-neutral-500 dark:text-neutral-400">
          Yuk bergabung bersama kami! Banyak keuntungan yang bisa kamu nikmatin
          mulai dari promosi, fitur menarik, juga koneksi{" "}
        </span>
        {userInfo ? (
          <ButtonPrimary
            className="mt-6 sm:mt-11 animate-bounce"
            href="/add-listing-1"
            targetBlank
          >
            Sewakan barangmu sekarang
          </ButtonPrimary>
        ) : (
          <ButtonPrimary
            className="mt-6 sm:mt-11 animate-bounce"
            href="/login?redirect=add-listing-1"
            onClick={() => {
              logging("", {
                category: "user",
                action: "cta",
              });
              eventAnalytic({
                category: "Product",
                action: "Register Now",
              });
            }}
          >
            Daftarkan dirimu sekarang
          </ButtonPrimary>
        )}
      </div>
      <div className="flex-grow">
        <NcImage src={becomeAuthor} className="rounded-3xl" />
      </div>
    </div>
  );
};

export default SectionBecomeAVendor;
